import React from 'react';
import EmptyPage from '../../SubComp/EmptyPage/EmptyPage';
import './MyOrder.css';


const MyOrderEmpty = () => {
  return (
    <div>
      <EmptyPage title='Orders' text='There are no orders. Browse Art'/>
    </div>
  )
}

export default MyOrderEmpty;